<template>
  <div>
    <p>
      <button
        class="btn btn-lg btn-block"
        :class="`btn-${removing ? 'danger' : 'success'}`"
        :disabled="saving || !unsavedChanges || removing"
        @click="saveChanges">
        <i class="fa fa-circle-o-notch fa-spin" v-show="saving || removing"/>
        <i class="fa fa-save" v-show="unsavedChanges && !saving && !removing"/>
        <i class="fa fa-check" v-show="!unsavedChanges && !saving && !removing && justSaved"/>
        {{ saveButtonText }}
      </button>
    </p>
    <p v-show="unsavedChanges">
      <button class="btn btn-block btn-default" @click="discardChanges"><i class="fa fa-undo"/> Discard changes</button>
    </p>
    <p class="text-center" v-if="lastUpdatedAt">
      <small class="text-muted">
        <i class="fa fa-clock-o"/> Last saved {{ lastUpdatedAt | formatTimeAgo }}
      </small>
    </p>
  </div>
</template>

<script>
export default {
  name: 'LibrarySaveChangesButtons',
  props: {
    saving: {
      required: true,
      type: Boolean
    },
    unsavedChanges: {
      required: true,
      type: Boolean
    },
    justSaved: {
      required: true,
      type: Boolean
    },
    lastUpdatedAt: {
      type: String,
      default: ''
    },
    saveButtonText: {
      required: true,
      type: String
    },
    removing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    saveChanges() {
      this.$emit('save')
    },
    discardChanges() {
      this.$emit('discard')
    }
  }
}
</script>

<style lang="less">
</style>
